export enum PlanStatusEnum {
    NotStarted = 0,
    Created = 1,
    Declined = 2,
}
